import { useMemo } from 'react';
import {
  anyAssetConstants,
  type ChainflipChain,
  type AnyChainflipChain,
} from '@chainflip/utils/chainflip';
import { isNotNullish } from '@chainflip/utils/guard';
import useSupportedAssets from '@/shared/hooks/useSupportedAssets';

export default function useSupportedChains(): ChainflipChain[];
export default function useSupportedChains(includeDeprecated: true): AnyChainflipChain[];
export default function useSupportedChains(includeDeprecated?: true) {
  const assets = useSupportedAssets('all', includeDeprecated);

  return useMemo(
    () => [
      ...new Set(
        assets
          .map((a) => {
            try {
              return anyAssetConstants[a].chain;
            } catch {
              return null;
            }
          })
          .filter(isNotNullish),
      ),
    ],
    [assets],
  );
}
